<template>
  <div class="sidebar" :style="sidebarStyle" :data-color="backgroundColor" :data-image="backgroundImage">
    <div class="sidebar-wrapper">
      <div class="logo d-flex" style="justify-content: center;">
        <a href="#" class="simple-text logo__container">


          <img src="../../../public/img/logosidebar.png" style="width:100px">
        </a>

      </div>

      <slot name="content"></slot>
      <ul class="nav nav-main__links">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot>
          <sidebar-link v-for="(link, index) in sidebarLinks" :key="link.name + index" :to="link.path"
            @click="closeNavbar" :link="link">
            <i :class="link.icon"></i>
            <p>{{ link.name }}</p>
          </sidebar-link>
        </slot>
      </ul>
      <ul class="nav nav-bottom" v-if="$slots['bottom-links']">
        <slot name="bottom-links"></slot>
      </ul>
    </div>
  </div>
</template>
<script>
import SidebarLink from './SidebarLink.vue'

export default {
  components: {
    SidebarLink
  },
  props: {
    title: {
      type: String,
      default: 'Vue LBD'
    },
    backgroundColor: {
    type: String,
    default: 'var(--sidebar-color)',
    validator: (value) => {
    console.log('Validating backgroundColor:', value); // Agrega esta línea para depurar
        const acceptedValues = ['var(--sidebar-color)', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black'];
        const hexColorPattern = /^#([0-9A-Fa-f]{6}|[0-9A-Fa-f]{3})$/;
        return acceptedValues.includes(value) || hexColorPattern.test(value);
      }
},
    backgroundImage: {
      type: String,
      default: '/img/menulateral.png'
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: (value) => {
        let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
        return acceptedValues.indexOf(value) !== -1
      }
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    }
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`
      }
    }
  }
}

</script>
<style>
.sidebar .sidebar-wrapper {
  display: flex;
  flex-direction: column;
}

.sidebar .nav-main__links {
  flex: 1;
}

.sidebar .sidebar-wrapper .logo .logo__container {
  padding-left: 10px;
}

@property --sidebar-color { 
  syntax: "<color>"; 
  inherits: false; 
  initial-value: #ffffff; 
}
</style>
